import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import "./PolicyRenewalModal.css";

import BrokerAppointmentForm from "./BrokerAppointmentForm";

const PolicyRenewalModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    full_name: "",
    contact_email: "",
    contact_number: "",
    contact_address: ""   // ✅ NEW
  });
  
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [brokerDocUrl, setBrokerDocUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showBrokerForm, setShowBrokerForm] = useState(false);
  

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles((prev) => [...prev, ...files]);
    e.target.value = null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!brokerDocUrl) {
      toast.warn("📄 Please finish the Broker Appointment form before submitting.");
      return;
    }
  
    try {
      setIsSubmitting(true);
      const data = new FormData();
  
      // Append form fields
      Object.entries(formData).forEach(([key, value]) => {
        data.append(key, value);
      });
  
      // Append files
      uploadedFiles.forEach((file) => {
        data.append("files", file);
      });
  
      // Append broker doc URL
      data.append("brokerDocUrl", brokerDocUrl);
  
      const res = await fetch("https://rcsbackend.onrender.com/send-policy-renewal", {

        method: "POST",
        body: data
      });
  
      const result = await res.json();
      if (result.success) {
        toast.success("✅ Policy Renewal Request Sent!");
        setFormData({
          full_name: "",
          contact_email: "",
          contact_number: "",
          contact_address: ""
        });
        setUploadedFiles([]);
        setBrokerDocUrl("");
        onClose();
      } else {
        toast.error("❌ Submission failed.");
      }
    } catch (err) {
      console.error("❌ Submission Error:", err);
      toast.error("❌ Failed to submit. Try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
<div className="modal-overlay">
  <div className="policy-modal-wrapper">
    <div className="modal-content">
      <h3>📄 Policy Renewal Request</h3>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Full Name"
            value={formData.full_name}
            onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="Contact Email"
            value={formData.contact_email}
            onChange={(e) => setFormData({ ...formData, contact_email: e.target.value })}
            required
          />
          <input
            type="tel"
            placeholder="Contact Number"
            value={formData.contact_number}
            onChange={(e) => setFormData({ ...formData, contact_number: e.target.value })}
            required
          />
<input
  type="text"
  placeholder="Address"
  value={formData.contact_address}
  onChange={(e) =>
    setFormData({ ...formData, contact_address: e.target.value })
  }
  required
/>

          <label className="upload-label">
            Upload Current Policy / ID (PDF/Image):
            <input
              type="file"
              accept="image/*,.pdf"
              multiple
              onChange={handleFileChange}
            />
          </label>

          <ul className="file-list">
            {uploadedFiles.map((file, i) => (
              <li key={i}>{file.name}</li>
            ))}
          </ul>

{/* 🔘 Toggle Button */}
<button
  type="button"
  className="toggle-button"
  onClick={() => setShowBrokerForm(!showBrokerForm)}
>
  {showBrokerForm ? "Hide Broker Appointment Form" : "Fill Broker Appointment Form"}
</button>

{showBrokerForm && (
  <BrokerAppointmentForm
  fullName={formData.full_name}
  address={formData.contact_address}
  onFinish={(file) => {
    toast.success("📄 Broker form attached!");
    setBrokerDocUrl(file); // now stores a File object instead of a URL
  }}
  
/>

)}

<div className="button-row">
  <button type="submit" disabled={isSubmitting}>
    {isSubmitting ? "Submitting..." : "Submit"}
  </button>
  <button type="button" className="cancel-btn" onClick={onClose}>
    Cancel
  </button>
</div>

        </form>
      </div>
    </div>
    </div>
  );
};

export default PolicyRenewalModal;
